
const AppEnv = {
    isProduction: true,
    /* theming config url */
}

export default AppEnv;